export default __webpack_public_path__ + "static/media/report.8d2e35e4.svg";